import { render } from "./DatasetManagement.vue?vue&type=template&id=2cebded8&scoped=true"
import script from "./DatasetManagement.vue?vue&type=script&lang=js"
export * from "./DatasetManagement.vue?vue&type=script&lang=js"

import "./DatasetManagement.vue?vue&type=style&index=0&id=2cebded8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cebded8"]])

export default __exports__